import React from 'react';
import { SafeAreaView, StyleSheet } from 'react-native';
import { ScrollView, TouchableOpacity } from 'react-native-gesture-handler';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import { CheckboxInner } from '../Checkbox';
import RowView from '../RowView';
import { useNavigation, useRoute } from '@react-navigation/core';
import { scale } from '../../utils/scale.utils';
import Icon from '../Icon';

const SelectorModal = () => {
  const navigation = useNavigation();
  const route = useRoute();

  const { returnScreen, options, selectedId, inputName } = route.params || {};
  const onSelect = (item) => {
    navigation.navigate(returnScreen, {
      selectedElement: { id: item.id, inputName },
    });
  };

  return (
    <SafeAreaView style={CommonStyles.flex1}>
      <ScrollView style={styles.container}>
        {options
          ? options.map((item) => (
              <TouchableOpacity key={item.id} onPress={() => onSelect(item)}>
                <RowView style={styles.item}>
                  <BaseText
                    style={[CommonStyles.h3, selectedId === item.id ? styles.textSelected : null]}
                  >
                    {item.label}
                  </BaseText>
                  <Icon
                    name="check"
                    style={[styles.icon, selectedId === item.id ? styles.iconSelected : null]}
                  />
                </RowView>
              </TouchableOpacity>
            ))
          : null}
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  icon: {
    fontSize: scale(18),
    color: Color.text.extraLow,
  },
  iconSelected: {
    color: Color.active,
  },
  item: {
    ...CommonProperties.px4,
    ...CommonProperties.py4,
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 0.05,
    borderBottomColor: Color.text.extraLow,
  },
  textSelected: {
    color: Color.active,
    fontWeight: 'bold',
  },
});

export default SelectorModal;
